<form [formGroup]="attributeFormGroup" class="no-field-space">

  <sc-flex vertical stretchContent>

    @for (attribute of articleType?.basicArticleDefinition?.attributes; track attribute; let i = $index) {
      @if (i > 0) {
        <sc-content-spacer vertical></sc-content-spacer>
      }
      @if ('STRING' == attribute.articleTypeAttribute?.type) {
        <mat-form-field appearance="fill">
          <mat-label><app-dictionary-entry-label
          [model]="attribute.articleTypeAttribute.name"></app-dictionary-entry-label></mat-label>
          <input matInput [formControlName]="'attr-'+attribute.attributeId"
            [required]="attribute.articleTypeAttribute.mandatory === true">
          </mat-form-field>
        }
        @if ('TEXT' == attribute.articleTypeAttribute?.type) {
          <mat-form-field appearance="fill">
            <mat-label><app-dictionary-entry-label
            [model]="attribute.articleTypeAttribute.name"></app-dictionary-entry-label></mat-label>
            <input matInput [formControlName]="'attr-'+attribute.attributeId"
              [required]="attribute.articleTypeAttribute.mandatory === true">
            </mat-form-field>
          }
          @if ('NUMBER' == attribute.articleTypeAttribute?.type) {
            <mat-form-field appearance="fill">
              <mat-label><app-dictionary-entry-label
              [model]="attribute.articleTypeAttribute.name"></app-dictionary-entry-label></mat-label>
              <input matInput type="number" [formControlName]="'attr-'+attribute.attributeId"
                [required]="attribute.articleTypeAttribute.mandatory === true">
              </mat-form-field>
            }
            @if ('DECIMAL' == attribute.articleTypeAttribute?.type) {
              <mat-form-field appearance="fill">
                <mat-label><app-dictionary-entry-label
                [model]="attribute.articleTypeAttribute.name"></app-dictionary-entry-label></mat-label>
                <input matInput type="number" [formControlName]="'attr-'+attribute.attributeId"
                  [required]="attribute.articleTypeAttribute.mandatory === true">
                </mat-form-field>
              }
              @if ('LOOKUP' == attribute.articleTypeAttribute?.type) {
                <mat-form-field appearance="fill">
                  <mat-label><app-dictionary-entry-label
                  [model]="attribute.articleTypeAttribute.name"></app-dictionary-entry-label></mat-label>
                  <mat-select [formControlName]="'attr-'+attribute.attributeId"
                    [required]="attribute.articleTypeAttribute.mandatory === true">
                    @for (value of attribute.articleTypeAttribute.values; track value) {
                      <mat-option [value]="value.id+''">
                        {{ value.value }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if ('BOOLEAN' == attribute.articleTypeAttribute?.type) {
                <mat-checkbox
                  [formControlName]="''+attribute.attributeId"
                  [required]="attribute.articleTypeAttribute.mandatory === true">
                  <app-dictionary-entry-label [model]="attribute.articleTypeAttribute.name"></app-dictionary-entry-label>
                </mat-checkbox>
              }
            }
          </sc-flex>
        </form>
